<script lang="ts">
import axios from 'axios';
import { defineComponent, PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AppSelect from '../../shared/AppSelect.vue';
import type { AppSelectOption } from '../../shared/AppSelect.vue';
import type { RosterType } from '@interfaces/roster_type';
import type { StructureType } from '@interfaces/structure_type';
import type { RosterFormatType } from '@interfaces/roster_format_type';
import { isRequestAborted } from '../../../utils/requestUtils';

export default defineComponent({
  name: 'RosterFormat',
  components: { AppSelect },
  props: {
    roster: {
      type: Object as PropType<RosterType>,
      required: true
    },
    structure: {
      type: Object as PropType<StructureType>,
      required: true
    }
  },
  setup() {
    const i18n = useI18n();
    return { t: i18n.t };
  },
  data() {
    return {
      formats: null as RosterFormatType[] | null,
    };
  },
  computed: {
    formatOptions(): AppSelectOption[] {
      if (!this.formats) return [];
      return this.formats.map((format) => ({
        value: format.id,
        label: String(format.format),
      }));
    },
  },
  created() {
    const self = this;
    const url = '/rosters/select_format.json';
    axios.get(url)
      .then(response => {
        self.formats = response.data.formats;
      })
      .catch((error) => {
        if (!isRequestAborted(error)) {
          console.error('Failed to load formats:', error);
        }
      });
  },
  methods: {
    onFormatChange(formatId: string | number) {
      const format = this.formats?.find(f => f.id === parseInt(String(formatId), 10));
      if (format) {
        this.structure.max_points = format.format;
      }
    },
  },
});
</script>

<template>
<div class="roster-format">
  <span class="roster-span">{{ t('roster_format.format') }}&nbsp;</span>
  <span class="roster-number roster-format__select-wrap">
    <AppSelect
      variant="compact"
      :model-value="roster.roster_format_id"
      :options="formatOptions"
      placeholder="-"
      @update:model-value="roster.roster_format_id = $event"
      @change="onFormatChange"
    />
  </span>
</div>
</template>
